import React, { memo } from 'react'
import { LinearProgress, linearProgressClasses } from '@mui/material'
import { varAlpha } from 'minimal-shared/utils'

const CustomLinearProgress = ({ completed, height = 6 }) => {
  return (
    <LinearProgress
      color='primary'
      variant='determinate'
      value={completed}
      sx={[
        (theme) => ({
          width: 1,
          height,
          bgcolor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
          [` .${linearProgressClasses.bar}`]: { opacity: 0.8 }
        })
      ]}
    />
  )
}

export default memo(CustomLinearProgress)
